import {
  Autocomplete,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import React from 'react';

export const SectionGenerateFile = ({
  fileInputRef,
  fileTypeList,
  fileTypeSelected,
  handleFileChange,
  handleFileUpdate,
  handleSelected,
  loadingUpdateFile,
  processingType,
  setProcessingType,
  scheduleDate,
  setScheduleDate,
  selectedFile,
}) => {
  const formatToLocalISO = (date) => {
    const localDate = new Date(date);
    localDate.setMinutes(localDate.getMinutes() - localDate.getTimezoneOffset());
    return localDate.toISOString().slice(0, 16);
  };

  const getCurrentISO = () => {
    const now = new Date();
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
    return now.toISOString().slice(0, 16);
  };

  return (
    <Paper
      elevation={3}
      sx={{ maxWidth: { xs: '100%', md: '1250px' }, margin: '0 auto', mb: '0.5rem' }}
    >
      <Typography variant="h5" sx={{ fontWeight: 700, textAlign: 'center', pt: '0.5rem' }}>
        Subir arquivo:
      </Typography>
      <Grid
        container
        spacing={2}
        alignItems="center"
        justifyContent="center"
        sx={{ marginTop: '0.5rem' }}
      >
        <Grid item>
          <Autocomplete
            options={fileTypeList}
            getOptionLabel={(option) => option?.filePrefix || ''}
            isOptionEqualToValue={(option, value) => option.filePrefix === value.filePrefix}
            value={fileTypeList.find((type) => type.filePrefix === fileTypeSelected) || null}
            onChange={handleSelected}
            renderInput={(params) => <TextField {...params} label="Tipo de arquivo" />}
            sx={{ minWidth: '14rem' }}
          />
        </Grid>

        <Grid item>
          <FormControl fullWidth variant="outlined" sx={{ minWidth: '14rem' }}>
            <InputLabel id="process-type-label">Processamento</InputLabel>
            <Select
              labelId="execution-type-label"
              value={processingType}
              onChange={(event) => setProcessingType(event.target.value)}
              label="Processamento"
            >
              <MenuItem value="scheduled">Agendado</MenuItem>
              <MenuItem value="manual">Manual</MenuItem>
              <MenuItem value="automatic">Imediato</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        {processingType === 'scheduled' && (
          <Grid item>
            <TextField
              fullWidth
              id="processedDate"
              label="Data para o processamento:"
              type="datetime-local"
              value={scheduleDate ? formatToLocalISO(scheduleDate) : ''}
              onChange={(e) => setScheduleDate(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                min: getCurrentISO(),
              }}
              color="primary"
              required
            />
          </Grid>
        )}

        <Grid item>
          <input
            type="file"
            accept=".csv, .txt"
            style={{ display: 'none' }}
            id="file-upload"
            onChange={handleFileChange}
            value=""
          />
          <label htmlFor="file-upload">
            <Button
              variant="contained"
              component="span"
              sx={{ width: '200px', height: '53px', fontWeight: 700 }}
            >
              Selecionar Arquivo
            </Button>
          </label>
        </Grid>

        <Grid item>
          <Button
            color="primary"
            disabled={
              !selectedFile ||
              fileTypeSelected === '' ||
              processingType === '' ||
              (processingType === 'scheduled' && scheduleDate === null) ||
              loadingUpdateFile
            }
            sx={{ width: '200px', height: '53px', fontWeight: 700 }}
            onClick={handleFileUpdate}
            variant="contained"
          >
            {loadingUpdateFile ? (
              <CircularProgress size={25} thickness={6} sx={{ color: '#fafafa' }} />
            ) : (
              'Enviar'
            )}
          </Button>
        </Grid>

        <Grid item md={12} xs={12} sx={{ color: 'red', textAlign: 'center' }}>
          {selectedFile && (
            <h4 style={{ padding: '1rem 0' }}>{`Arquivo selecionado: ${selectedFile?.name}`}</h4>
          )}
        </Grid>
      </Grid>
    </Paper>
  );
};

